<template>
    <ui-crud :title="this.packageReference?'Package Tasks':'Your Tasks'" :subtitle="this.packageReference?'View tasks related to this package.':'Manage tasks assigned to you.'" :fetch="fetch" :group-by="groupByStatus"
             :pipe-with="sortByStatus">

        <!-- Filters. -->
        <template #filters="{ debouncedRefresh }">
            <div class="relative">
                <ui-input class="mt-6" field="bg-gray-50 pr-10" name="search" v-model="search"
                          @input="debouncedRefresh()"></ui-input>
                <div class="absolute right-0 inset-y-0 h-full flex items-center justify-center p-3 text-gray-400">
                    <i class="fas fa-search"></i>
                </div>
            </div>
        </template>

        <!-- List item. -->
        <template #list-item="{ item, select, active }">
            <ui-crud-card
                :title="item.name"
                :subtitle="(item.has_package ? item.package.common : '—')"
                :metadata="item.due"
                :active="active"
                @click="select()"
            ></ui-crud-card>
        </template>

        <!-- Create form. -->
        <template #create="{ addItem }">
            <tasks-crud-form :add-item="addItem"></tasks-crud-form>
        </template>

        <!-- Edit form. -->
        <template #edit="{ selectedItem, setEditMode }">
            <tasks-crud-form :item="selectedItem" :edit="setEditMode"></tasks-crud-form>
        </template>

        <!-- Show page. -->
        <template #show="{ selectedItem, setEditMode, removeItem }">
            <tasks-crud-show :item="selectedItem" :edit="setEditMode" :removeItem="removeItem"></tasks-crud-show>
        </template>
    </ui-crud>
</template>

<script>
import {Task} from '@models'

export default {
    props: {
        packageReference: null,
    },
    data() {
        return {
            search: '',
        }
    },
    methods: {
        async fetch() {
            return await Task.all(this.search, this.packageReference)
        },
        sortByStatus(tasks) {
            tasks = _.orderBy(tasks, function (task) {
                return (task.due ? task.due : '')
            }, 'ASC')

            return _.orderBy(tasks, function (task) {
                return (task.complete ? '1' : '0')
            }, 'ASC')
        },
        groupByStatus(task) {
            return task.complete ? 'Recently Completed' : 'Todo'
        },
    }
}
</script>
